module.exports = __webpack_public_path__ + "static/img/h-i-5.d19fc4d6.png";